import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

export const PasswordSection = ({
  passwordData,
  setPasswordData,
  handlePasswordChange,
  passwordLoading,
  hasPasswordData,
}) => {
  const [showCurrentPw, setShowCurrentPw] = useState(false);
  const [showNewPw, setShowNewPw] = useState(false);

  return (
    <div className="bg-background rounded-lg p-6 mb-6">
      <h2 className="text-xl font-bold mb-4">Cambiar Contraseña</h2>
      <form
        onSubmit={handlePasswordChange}
        className="space-y-4"
        data-testid="password-change-form"
      >
        <div>
          <label className="text-sm font-medium mb-2 block">
            Contraseña Actual
          </label>
          <div className="relative">
            <Input
              type={showCurrentPw ? "text" : "password"}
              value={passwordData.current_password}
              onChange={(e) =>
                setPasswordData({
                  ...passwordData,
                  current_password: e.target.value,
                })
              }
              placeholder="Ingresa tu contraseña actual"
              data-testid="current-password-input"
            />
            <button
              type="button"
              onClick={() => setShowCurrentPw(!showCurrentPw)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            >
              {showCurrentPw ? (
                <EyeOff className="w-4 h-4" />
              ) : (
                <Eye className="w-4 h-4" />
              )}
            </button>
          </div>
        </div>
        <div>
          <label className="text-sm font-medium mb-2 block">
            Nueva Contraseña
          </label>
          <div className="relative">
            <Input
              type={showNewPw ? "text" : "password"}
              value={passwordData.new_password}
              onChange={(e) =>
                setPasswordData({
                  ...passwordData,
                  new_password: e.target.value,
                })
              }
              placeholder="Mínimo 6 caracteres"
              data-testid="new-password-input"
            />
            <button
              type="button"
              onClick={() => setShowNewPw(!showNewPw)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            >
              {showNewPw ? (
                <EyeOff className="w-4 h-4" />
              ) : (
                <Eye className="w-4 h-4" />
              )}
            </button>
          </div>
        </div>
        <div>
          <label className="text-sm font-medium mb-2 block">
            Confirmar Nueva Contraseña
          </label>
          <Input
            type="password"
            value={passwordData.confirm_password}
            onChange={(e) =>
              setPasswordData({
                ...passwordData,
                confirm_password: e.target.value,
              })
            }
            placeholder="Repite la nueva contraseña"
            data-testid="confirm-password-input"
          />
          {passwordData.new_password &&
            passwordData.confirm_password &&
            passwordData.new_password !== passwordData.confirm_password && (
              <p className="text-xs text-destructive mt-1">
                Las contraseñas no coinciden
              </p>
            )}
        </div>
        <Button
          type="submit"
          disabled={passwordLoading || !hasPasswordData}
          className="w-full sm:w-auto"
          data-testid="change-password-button"
        >
          {passwordLoading ? "Cambiando..." : "Cambiar Contraseña"}
        </Button>
      </form>
    </div>
  );
};
